import { DeliveryDestinations } from 'customers';

export interface CompanySearchResult {
  idBusinessPartner: string;
  ragioneSociale: string;
  codiceFiscale?: string | null;
  partitaIva?: string | null;
  provincia?: string | null;
  indirizzo?: string | null;
  cribis?: boolean;
  destini?: DeliveryDestinations[];
}

// Cliente ancora da creare: non viene simulato un ID business partner del backend.
export interface ManualCustomer extends Omit<CompanySearchResult, 'idBusinessPartner'> {
  idBusinessPartner: null;
  source: 'manual';
  draftId: string;
  ragioneSociale: string;
  codiceFiscale: string;
  partitaIva: string;
  indirizzo: string;
  localita: string;
  provincia: string;
  cap: string;
}

export type CustomerConfigurationCustomer = CompanySearchResult | ManualCustomer;

export function isManualCustomer(customer: CustomerConfigurationCustomer): customer is ManualCustomer {
  return 'source' in customer && customer.source === 'manual';
}
